import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NetworkDelayPopoverComponent } from './network-delay-popover.component';

@NgModule({
    imports: [CommonModule, NgbPopoverModule, TranslateModule.forChild()],
    exports: [NetworkDelayPopoverComponent],
    declarations: [NetworkDelayPopoverComponent],
    providers: []
})
export class NetworkDelayPopoverModule {}
